import React from 'react';
import './ToggleSwitch.css';

/**
 * Premium Apple iOS-style Kippschalter.
 * 
 * @component ToggleSwitch
 * @param {Object} props
 * @param {boolean} props.checked - Status des Schalters.
 * @param {Function} props.onChange - Callback, wenn der Schalter gekippt wird. Returns boolean.
 * @param {string} props.label - Haupt-Label-Text.
 * @param {string} [props.subtext] - Kleiner Beschreibungstext unter dem Label.
 * @param {boolean} [props.disabled] - Deaktiviert-Status.
 */
export default function ToggleSwitch({ checked, onChange, label, subtext, disabled }) {
    return (
        <label className={`co-switch-container ${disabled ? 'disabled' : ''}`}>
            <div className="co-switch-label-block">
                {label && <span className="co-switch-label">{label}</span>}
                {subtext && <span className="co-switch-subtext">{subtext}</span>}
            </div>
            <div className="co-switch-wrapper">
                <input
                    type="checkbox"
                    checked={!!checked}
                    onChange={(e) => onChange && onChange(e.target.checked)}
                    disabled={disabled}
                />
                <span className="co-switch-slider" />
            </div>
        </label>
    );
}
